import axios from 'axios';

const QUESTIONS_URL = `${process.env.VUE_APP_API}/nscampaignquestion`;

export const QuestionsApiService = {
  fetchQuestion(questionsId) {
    return axios.get(`${QUESTIONS_URL}/${questionsId}`);
  },
};

export const ProgramInviteService = {
  submitCouponProgramInvite(body, accesstoken) {
    return axios.post(
      `${process.env.VUE_APP_API}/coupons/programinvite`,
      body,
      {
        headers: {
          Authorization: `Access ${accesstoken}`,
        },
      },
    );
  },
};
